import { useMemo } from 'react'

import { useSelector } from 'react-redux'
import { sortBy } from 'lodash'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { Nationalities } from '../../../utils/constants'
import EntitiesSelector from './EntitiesSelector'

const NationalitiesSelector = ({ className = '', disabled, multiple = 'default', placeholder, showSearch, style = {}, tagPlaceholder, values, onChange }) => {
  const t = useSelector(selectTranslate)

  const nationalitiesOptions = useMemo(() => sortBy(Object.values(Nationalities).map(label => ({
    label: t('nationalities.' + label.toLowerCase()),
    value: label
  })), ['label']), [t])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={nationalitiesOptions}
      multiple={multiple}
      placeholder={placeholder}
      showSearch={showSearch}
      style={style}
      tagPlaceholder={tagPlaceholder}
      values={values}
      onChange={onChange}
    />
  )
}

export default NationalitiesSelector
